import { parkingModeSelector } from '@booking/selectors'
import { SEARCH_MODE_PREPAID } from 'search/constants'

export const stateSelector = state => state.confirmation

export const parkingPassUrlSelector = createSelector(
    stateSelector,
    parkingModeSelector,
    (confirmation, parkingMode) => parkingMode !== SEARCH_MODE_PREPAID && confirmation.parkingPassUrl
)
export const parkingPassRequirementsSelector = createSelector(
    stateSelector,
    confirmation => confirmation.parkingPassRequirements
)

export const confirmedReservationIdSelector = createSelector(
    stateSelector,
    confirmation => confirmation.confirmationNumber
)

export const confirmedReservationEmailAddressSelector = createSelector(
    stateSelector,
    confirmation => confirmation.orderEmailAddress
)
